import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import DzienOjca from './components/dzien-ojca/DzienOjca';
import Header from './components/Header';
import Invitation from './components/invitation/Invitation';
import MainPage from './components/MainPage';
import ProjectDisplayer from './components/ProjectDisplayer';
import { data } from './ProjectsDescription';

const TRACKING_ID1 = 'G-L5RKPQR0H9';

ReactGA.initialize(TRACKING_ID1);

export type Project = {
	title: string;
	description: string;
	media: string[];
	path: string;
	repoUrl: string;
	fullWidth: boolean;
	showcaseComponent?: JSX.Element;
};

function App() {
	const [fileContent, setFileContent] = useState<Project[]>();
	useEffect(() => {
		setFileContent(data);

		console.log('data fetched');
		ReactGA.send({
			hitType: 'pageview',
			page: window.location.pathname,
			title: 'Main page',
		});
	}, []);

	return (
		<Router>
			<Header />
			<Routes>
				<Route path="/" element={<MainPage />} />
				<Route path="/invitation-julcia" element={<Invitation />} />
				<Route path="/*" element={<ProjectDisplayer fileContent={fileContent} />} />
				<Route path="/d9b5989ea1a82edfd722cd5ffe6ba6d026ff00b369bf8ff7f332165a717c07de" element={<DzienOjca />} />
			</Routes>
		</Router>
	);
}

export default App;
